<template>
  <div>
    <b-modal
      @show="onShow"
      @hidden="onCancel();"
      header-class="dlg_header"
      dialog-class="c-dialog-min"
      centered
      :visible="visible"
      hide-footer
    >
      <template #modal-header="{close}">
        <div class="dlg_title1">{{ $t('more.address_search') }}</div>
        <b-button class="dlg_close_btn" variant="white" @click="onCancel">
          <b-img :src="require('../../../assets/image/ic_close2.png')" style="height: 1em; margin-left: 7px; margin-right: 3px; "/>
        </b-button>
      </template>
      <div class="body align-vertical">
        <div class="align-horizontal" @click="onSearch">
          <b-form-input style="border-top-right-radius: 0; border-bottom-right-radius: 0" disabled
                        class="input input_wrapper" v-model="keyword" :placeholder="$t('more.address_popup_placeholder')"/>
          <b-button variant="primary" class="search_btn">
            <b-img :src="require('../../../assets/image/ic_search_white@2x.png')" style="height: 20px;" />
          </b-button>
        </div>
        <b-button class="loc_btn" variant="white" @click="onMap">
          <b-img :src="require('../../../assets/image/ic_gps_blue@2x.png')" style="width: 16px; height: 16px" />
          <span class="loc_btn_text">{{$t('more.set_cur_location')}}</span>
        </b-button>
        <div class="align-vertical addr_info">
          <div class="addr_text">{{address.replace((address.split(' '))[0],'')}}</div>
          <div class="align-horizontal v_center" style="margin-top: 5px">
            <div class="road_badge" v-if="road_name != ''">
              <label class="road_badge_text">{{$t('more.road_name')}}</label>
            </div>
            <label class="road_name_text">{{(road_name.split(' '))[1]}} {{(road_name.split(' '))[2]}} {{(road_name.split(' '))[3]}}</label>
          </div>
        </div>
        <b-form-input class="input input_wrapper" style="margin-top: 10px"
                      ref="inputDetail"
                      v-model="detail_address"
                      @change="onConfirm"
                      :placeholder="$t('more.detail_address_placeholder')"/>
        <b-button class="confirm_btn confirm_btn_text" variant="primary" @click="onConfirm">
          {{$t('common.confirm')}}
        </b-button>
      </div>
    </b-modal>
    <MapPopup :visible.sync="showMap" @onConfirm="(addr, road) => {
      this.address = addr;
      this.road_name = road;
      this.$refs.inputDetail.focus();
      this.showMap = false;
    }" />
    <DaumPostPopup :visible.sync="showDaumPostPopup" @onConfirm="onSelectFromDaumPost" />
  </div>
</template>

<script>
import Utils from "../../../config/utils";
import MapPopup from "./MapPopup";
import DaumPostPopup from "./DaumPostPopup";
export default {
  name: "AddressSearchPopup",
  components: {DaumPostPopup, MapPopup},
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
  },
  data() {
    return {
      keyword: '',
      address: '',
      road_name: '',
      detail_address: '',
      showMap: false,
      showDaumPostPopup: false,
    }
  },
  mounted() {
    this.myinfo.tmpAddress = "";
    this.myinfo.tmpRoadAddress = "";

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.myinfo.latitude = pos.coords.latitude;
          this.myinfo.longitude = pos.coords.longitude;
          this.getCurrentAddress(this.myinfo.latitude, this.myinfo.longitude);
        },
        (err) => {
          this.myinfo.latitude = 37.51762440574381;
          this.myinfo.longitude = 126.95891619231263;
          this.getCurrentAddress(this.myinfo.latitude, this.myinfo.longitude);
        }
      );
    }
    //TODO:현재 자기위치 얻기 (info 객체변수에 위도, 경고정보를 넣어주십시오)
    // let info={coords:{latitude: 0, longitude: 0}}

    // this.myinfo.latitude = Number(info.coords.latitude);
    // this.myinfo.longitude = Number(info.coords.longitude);
    // if (this.myinfo.latitude == 0) {
    //   this.myinfo.latitude = 37.566826;
    //   this.myinfo.longitude = 126.9786567;
    // }

  },
  methods:{
    onSelectFromDaumPost() {
      Utils.setState(this,{
        showDaumPostPopup: false,
        address: this.myinfo.tmpAddress,
        road_name: this.myinfo.tmpRoadAddress
      }, () => this.$refs.inputDetail.focus());
      fetch('https://dapi.kakao.com/v2/local/search/address.json?query=' + this.myinfo.tmpSearchAddress + '&pag=1&size=10', {
        headers: {
          'Authorization': 'KakaoAK e398bc45713e267138212b3e3da37c80',
        }
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson.meta.total_count > 0) {
            this.myinfo.tmpLatitude = responseJson.documents[0].y;
            this.myinfo.tmpLongitude = responseJson.documents[0].x;
          } else {

          }

        })
    },
    onShow() {
      this.keyword = '';
      this.address= '';
      this.road_name= '';
      this.detail_address= '';
      this.showMap= false;
      this.showDaumPostPopup= false;
    },
    onCancel() {
      this.$emit('update:visible', false);
    },
    onSearch() {
      Utils.setState(this,{showDaumPostPopup: true})
    },
    onMap() {
      Utils.setState(this,{showMap: true})
    },
    onConfirm() {
      this.$emit('onConfirm', this.address, this.detail_address)
      this.$emit('update:visible', false);
    },

    getCurrentAddress(lat, lon) {
      fetch('https://dapi.kakao.com/v2/local/geo/coord2address.json?input_coord=WGS84&x=' + lon + '&y=' + lat, {
        headers: {
          'Authorization': 'KakaoAK e398bc45713e267138212b3e3da37c80',
        }
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson.meta.total_count > 0) {
            var addressInfo = responseJson.documents[0];
            var jibunInfo = addressInfo.address;
            this.myinfo.address = jibunInfo.address_name;
            var roadInfo = addressInfo.road_address;
            if (roadInfo != null) {
              this.myinfo.roadAddress = roadInfo.address_name;
            }
          } else {

          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/_vars.scss";
.form-control:disabled, .form-control[readonly] {
  background-color: white !important;
  opacity: 1;
}
.body {
  padding: 15px 24px;
}
.input{
  color: black;
  font-size: $fs_16;
  font-family: $korean_gd_14_r;
}
.input_wrapper{
  height: 40px;
  border-width: 0.5px;
  border-color: #bebdbd;
  border-radius: 3px;
}
.search_btn {
  width: 40px;
  height: 40px;
  background-color: $c_457fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0 3px 3px 0;
}
.loc_btn {
  display: flex;
  height: 40px;
  margin-top: 8px;
  border-width: 0.5px;
  border-color: $c_457fff;
  border-radius: 5px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.loc_btn_text {
  color: $c_457fff;
  font-size: $fs_16;
  font-family: $korean_gd_15_r;
  margin-left: 3px;
}
.addr_info {
  margin-top: 10px;
  height: 90px;
  border-radius: 5px;
  background-color: #f7f6f6;
  padding-right: 15px;
  padding-left: 15px;
  justify-content: center;
}
.addr_text {
  color: black;
  font-size: $fs_18;
  font-family: $korean_gd_16_r;
}
.road_badge {
  width: 47px;
  height: 27px;
  border: solid 1px;
  borderColor: black;
  background-color: white;
  justify-content: center;
  align-items: center;
}
.road_badge_text{
  color: black;
  font-size: $fs_15;
  font-family: $korean_gd_11_r;
  margin-bottom: 0px;
  margin-left: 3px;
}
.road_name_text {
  color: #717171;
  font-size: $fs_18;
  font-family: $korean_gd_14_r;
  margin-left: 6px;
  margin-bottom: 0px;
}
.confirm_btn {
  margin-top: 13px;
  height: $button_height1;
  background-color: $c_457fff;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  width: 100%;
}
.confirm_btn_text {
  color: $white;
  font-size: $fs_18;
  font-family: $korean_gd_15_r
}
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/AddressSearchPopup.vue